import React from "react";
import { Text } from "./Text";
import clsx from "clsx";
import styled from "styled-components";

const CircleWrapper = styled.div`
  width: ${(props) => (props.width ? props.width : "50px")};
  height: ${(props) => (props.height ? props.height : "50px")};
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : "black")};
  color: ${(props) => (props.color ? props.color : "white")};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  position: relative;
`;

const SmallCircle = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #FF6347;
  border: 2px solid #FFF;
`;

const Circle = ({ number, children, ...props }) => {
  return (
    <CircleWrapper
      width={props?.width ?? '50px'}
      height={props?.height ?? '50px'}
      className={clsx("circle", props?.className)}
      ref={props?.reference}
      color={props?.color}
      backgroundColor={props?.backgroundColor}
    >
      {number ? (
        <Text $fontColor={props?.color ?? "white"} $fontSize="text_md" $weight="">
          {number}
        </Text>
      ) : null}
      {props.isIcon ? children : null}
      {props.hasSmallCircle ? <SmallCircle /> : null}
    </CircleWrapper>
  );
};

export default Circle;
